import { max, tau } from "./math.js";

function range(i, j) {
  return Array.from({
    length: j - i
  }, function (_, k) {
    return i + k;
  });
}

function compareValue(compare) {
  return function (a, b) {
    return compare(a.source.value + a.target.value, b.source.value + b.target.value);
  };
}

export default function () {
  return chord(false, false);
}
export function chordTranspose() {
  return chord(false, true);
}
export function chordDirected() {
  return chord(true, false);
}

function chord(directed, transpose) {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = new Array(n),
        groupIndex = range(0, n),
        chords = new Array(n * n),
        groups = new Array(n),
        k = 0,
        dx;
    matrix = Float64Array.from({
      length: n * n
    }, transpose ? function (_, i) {
      return matrix[i % n][i / n | 0];
    } : function (_, i) {
      return matrix[i / n | 0][i % n];
    }); // Compute the scaling factor from value to angle in [0, 2pi].

    for (var i = 0; i < n; ++i) {
      var x = 0;

      for (var j = 0; j < n; ++j) {
        x += matrix[i * n + j] + directed * matrix[j * n + i];
      }

      k += groupSums[i] = x;
    }

    k = max(0, tau - padAngle * n) / k;
    dx = k ? padAngle : tau / n; // Compute the angles for each group and constituent chord.

    {
      var _x = 0;
      if (sortGroups) groupIndex.sort(function (a, b) {
        return sortGroups(groupSums[a], groupSums[b]);
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var i = _step.value;
          var x0 = _x;

          if (directed) {
            var subgroupIndex = range(~n + 1, n).filter(function (j) {
              return j < 0 ? matrix[~j * n + i] : matrix[i * n + j];
            });
            if (sortSubgroups) subgroupIndex.sort(function (a, b) {
              return sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]);
            });
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = subgroupIndex[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _j = _step2.value;

                if (_j < 0) {
                  var _chord = chords[~_j * n + i] || (chords[~_j * n + i] = {
                    source: null,
                    target: null
                  });

                  _chord.target = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[~_j * n + i] * k,
                    value: matrix[~_j * n + i]
                  };
                } else {
                  var _chord2 = chords[i * n + _j] || (chords[i * n + _j] = {
                    source: null,
                    target: null
                  });

                  _chord2.source = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j] * k,
                    value: matrix[i * n + _j]
                  };
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            groups[i] = {
              index: i,
              startAngle: x0,
              endAngle: _x,
              value: groupSums[i]
            };
          } else {
            var _subgroupIndex = range(0, n).filter(function (j) {
              return matrix[i * n + j] || matrix[j * n + i];
            });

            if (sortSubgroups) _subgroupIndex.sort(function (a, b) {
              return sortSubgroups(matrix[i * n + a], matrix[i * n + b]);
            });
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = _subgroupIndex[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _j2 = _step3.value;

                var _chord3 = void 0;

                if (i < _j2) {
                  _chord3 = chords[i * n + _j2] || (chords[i * n + _j2] = {
                    source: null,
                    target: null
                  });
                  _chord3.source = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j2] * k,
                    value: matrix[i * n + _j2]
                  };
                } else {
                  _chord3 = chords[_j2 * n + i] || (chords[_j2 * n + i] = {
                    source: null,
                    target: null
                  });
                  _chord3.target = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j2] * k,
                    value: matrix[i * n + _j2]
                  };
                  if (i === _j2) _chord3.source = _chord3.target;
                }

                if (_chord3.source && _chord3.target && _chord3.source.value < _chord3.target.value) {
                  var source = _chord3.source;
                  _chord3.source = _chord3.target;
                  _chord3.target = source;
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            groups[i] = {
              index: i,
              startAngle: x0,
              endAngle: _x,
              value: groupSums[i]
            };
          }

          _x += dx;
        };

        for (var _iterator = groupIndex[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } // Remove empty chords.

    chords = Object.values(chords);
    chords.groups = groups;
    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function (_) {
    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
  };

  chord.sortGroups = function (_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function (_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function (_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
}